const Menu = () => {
  return (
    <nav className="bg-black flex justify-center px-5 border-blue border-b-[3px] h-[50px]">
      <img
        src="/img/ford_logo.svg"
        alt="Ford"
        className="shrink-0 my-[5px] pt-2 pb-2"
      />
    </nav>
  );
};

export default Menu;
